import axios from '../plugins/axios'

export default {
  data() {
    return {
      loading: false,
      success: false,
      messageType: 'error',

      // prices
      monthlyPrice: 0,
      annualPrice: 0,
      annualFullPrice: 0,
      annualDiscount: 0,

      // plugin settings
      site_url: '',
      product_id: 0,
      finish: '',
      px: 0,
      position_x: '',
      position_y: '',

      // coupons
      couponLoading: false,
      couponApplied: false,
      coupon: '',
      couponMessage: '',
      couponDiscountAmount: 0,
      couponPlan: '',
    }
  },

  // initial data
  beforeMount() {
    const data = JSON.parse(this.$el.dataset.initial)

    for (const key in this.$data) {
      if (key in data) {
        this[key] = data[key]
      }
    }
  },

  methods: {
    checkout () {
      if (this.loading) {
        return
      }

      this.messageType = 'error'
      this.errors.clear()

      this.$validator.validate().then(result => {
        if (!result) {
          this.loading = false
          return
        }

        this.submit()
      })
    },

    applyCoupon() {
      this.messageType = 'error'
      this.errors.clear()

      if (! this.coupon) {
        this.errors.add( { msg: 'לא הוזן קופון.', field: 'coupon' } )
        return
      }

      const formData = new FormData()
      formData.append('action', 'ia_apply_coupon')
      formData.append('coupon', this.coupon)

      this.couponLoading = true
      this.couponApplied = false

      axios.post('', formData)
        .then(response => {
          this.couponLoading = false
          this.couponApplied = true

          for (const key in response.data.data) {
            if (key in this) {
              this[key] = response.data.data[key]
            }
          }

          const plan = 'שנתית'
          this.couponMessage = `הפעלת קופון ${this.coupon} המעניק ${this.couponDiscountAmount}% הנחה על החבילה ה${this.couponPlan}.`
        })
        .catch(error => {
          this.errors.add({ msg: error.response.data.data.message })
          this.couponLoading = false
        })
    },

    submit () {
      const formData = new FormData(this.$el)

      this.loading = true
      this.messageType = 'error'
      this.errors.clear()

      formData.append('coupon', this.coupon)

      axios.post('', formData)
        .then(response => {
          this.success = true

          location.href = response.data.redirect
        })
        .catch(error => {
          this.errors.add({ msg: error.response.data.data.message })
          this.loading = false
        })
    },
  },
}


// WEBPACK FOOTER //
// ./src/controllers/checkout.js